// extracted by mini-css-extract-plugin
export default {"Insights":"IGD_Insights__zBJpO","Box":"IGD_Box__vVnSo","Middle":"IGD_Middle__oGO5S","Left":"IGD_Left__jOH7r","Progress":"IGD_Progress__WDnJw","TextMuted":"IGD_TextMuted__C8imT"};